import { usePayseraPaymentStatusLazyQuery } from 'api/core/generated';
import { APP_POLLING_INTERVALS, AppApiVersions } from 'app-constants';

export const useGetBanklinkPaymentStatus = () => {
  const [
    startBanklinkPaymentStatusPolling,
    { data, loading, error, stopPolling },
  ] = usePayseraPaymentStatusLazyQuery({
    context: { apiVersion: AppApiVersions.core },
    pollInterval: APP_POLLING_INTERVALS.default,
  });

  return {
    startBanklinkPaymentStatusPolling,
    banklinkPaymentStatus: data?.payment_status,
    banklinkPaymentStatusLoading: loading,
    banklinkPaymentStatusError: error,
    stopBanklinkPaymentStatusPolling: stopPolling,
  };
};
